import { render, staticRenderFns } from "./followRecordDetail.vue?vue&type=template&id=e7779800&scoped=true&"
import script from "./followRecordDetail.vue?vue&type=script&lang=js&"
export * from "./followRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./followRecordDetail.vue?vue&type=style&index=0&id=e7779800&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7779800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7779800')) {
      api.createRecord('e7779800', component.options)
    } else {
      api.reload('e7779800', component.options)
    }
    module.hot.accept("./followRecordDetail.vue?vue&type=template&id=e7779800&scoped=true&", function () {
      api.rerender('e7779800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/bigCustomer/followRecord/followRecordDetail.vue"
export default component.exports